// API Configuration
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';
export const WS_URL = process.env.REACT_APP_WS_URL || 'http://localhost:5001';


